module.exports = "https://static.wmbcdn.com/uniweb/images/89a5bd604a33ca44c55e42ee4ef01d2b.svg";